import { IStaticAccordion } from "../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../Model/Enum/BEE123Enums";

export const BBBEE_Resources: Array<IStaticAccordion> = [
  {
      title: "BEE GUIDE",
      groups: [
        {
          items: [
            {
              title: "BEE123 Guide",
              link:
                "BEE Guide/BEE123 SYSTEM USER GUIDE- BEE Module- 2024.pdf",
              section: LegislationSections.Templates
            },
            {
              title: "BEE123 User Guide - VA Excel Export",
              link:
                "BEE Guide/BEE123 User Guide_VA Excel Export.pdf",
              section: LegislationSections.Templates
            },
          ],
        },
      ],
    },
    {
      title: "AFFIDAVITS",
      groups: [
        {
          items: [
            {
              title: "Exempted Micro Enterprise - Agro Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_Agri.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - Construction Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_CSC.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - Forestry Sector COdes",
              link:
                "Affidavits/BEE_Affidavit_EME_Gen_Forestry.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - General",
              link:
                "Affidavits/BEE_Affidavit-EME-Gen.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - ICT Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_ICT.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - MAC Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_MAC.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - Property Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_PSC.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - Specialised - General",
              link:
                "Affidavits/BEE_Affidavit-EME-Spec.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Exempted Micro Enterprise - Tourism Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_EME_Tourism.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - Agri Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE_Agri.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - Forestry Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE-Affidavit_Gen_Forestry.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - General",
              link:
                "Affidavits/BEE_Affidavit-QSE-Gen.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - ICT Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE_ICT.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - MAC Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE_MAC.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - Property Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE_PSC.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - Specialised - General",
              link:
                "Affidavits/BEE_Affidavit-QSE-Spec.pdf",
              section: LegislationSections.Templates,
            },
            {
              title: "Qualifying Small Enterprise - Tourism Sector Codes",
              link:
                "Affidavits/BEE_Affidavit_QSE_Tourism.pdf",
              section: LegislationSections.Templates,
            },
          ],
        }
      ]
    },
    {
      title: "ENTERPRISE & SUPPLIER DEVELOPMENT",
      groups: [
        {
          items: [
            {
              title: "Enterprise Development Confirmation Letter",
              link:
                "Enterprise Development/ED Confirmation letter.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Enterprise Development Agreement",
              link:
                "Enterprise Development/Enterprise Development Agreement.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Supplier Development Confirmation Letter",
              link:
                "Supplier Development/SD Confirmation letter.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Supplier  Development Agreement",
              link:
                "Supplier Development/Supplier  Development Agreement.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "FINANCIAL INFORMATION",
      groups: [
        {
          items: [
            {
              title: "Confirmation Letter of Management Account Figures",
              link:
                "Financial info/Confirmation letter of management account figures.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "MANAGEMENT CONTROL",
      groups: [
        {
          items: [
            {
              title: "Confirmation Letter of EAP Target",
              link:
                "Management Control/Confirmation letter of EAP target.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Confirmation of Management  Structure",
              link:
                "Management Control/Confirmation of Management Structure.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "EEA1",
              link:
                "Management Control/EEA1.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Non-executive Director Declaration",
              link:
                "Management Control/Nonexecutive director declaration.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "OWNERSHIP",
      groups: [
        {
          items: [
            {
              title: "Black New Entrant Declaration",
              link:
                "Ownership/Black new entrant declaration.docx",
              section: LegislationSections.Templates,
            },
  
            {
              title: "Black Designated Groups Declaration",
              link:
                "Ownership/Declaration Of Black Designated Groups.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "PROCUREMENT",
      groups: [
        {
          items: [
            {
              title: "Import Plan Template",
              link:
                "Procurement/Import Plan Template.docx",
              section: LegislationSections.Templates,
            },
            {
              title: "Enterprise and Supplier Development Plan",
              link:
                "Procurement/PCA_ESD Plan.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "SKILLS DEVELOPMENT",
      groups: [
        {
          items: [
            {
              title: "Sworn Affidavit Regarding Unemployment",
              link:
                "Skills Development/Sworn Affidavit regarding unemployment.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
    {
      title: "SOCIO-ECONOMIC DEVELOPMENT",
      groups: [
        {
          items: [
            {
              title: "Socio-Economic Development Confirmation",
              link:
                "Socio-Economic Development/SED Confirmation Template.docx",
              section: LegislationSections.Templates,
            },
          ],
        },
      ],
    },
];
  